<script lang="ts">
  import clsx from "clsx";

  export let show = false,
    closeOnOutsideClick = true,
    onClose: () => void;

  const onOverlayClick = () => {
    if (!closeOnOutsideClick) return;
    onClose();
  };
</script>

<div
  on:mouseup|stopPropagation={onOverlayClick}
  on:click|stopPropagation
  on:mousedown|stopPropagation
  on:touchstart|stopPropagation
  class={clsx(
    "left-0 top-0 w-full h-full absolute z-50 bg-transparent flex flex-col justify-center items-center transition-top duration-300 ease",
    !show && "hidden"
  )}
>
  <div on:mouseup|stopPropagation class="relative max-w-[90%] w-[90%]">
    <slot />
  </div>
</div>
